import { UseQueryResult } from '@tanstack/react-query';

import { API_QUERY_KEYS, getOutstandingResponsesReport, useBaseReport } from 'api';
import { ReportResponse } from 'types';

export const useOutstandingResponsesReport = (): UseQueryResult<ReportResponse> =>
  useBaseReport(API_QUERY_KEYS.getOutstandingResponsesReport, getOutstandingResponsesReport);
